// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_dx-0";
export var headerCellHover = "_dx-1";